import {MwError} from './MwError';

const getErrorMessage = (e) => {
    if (!e) return;

    return `${e}${e.code !== undefined ? ', code: ' + e.code : ''}`;
};

export const createError = (mwError, message, details = {}) => {
    return new MwError({message, code: mwError?.code, details});
};

export default {
    getErrorMessage,
    createError,
};
